export class LiberacaoDesconto {
  public idliberacaodesconto: number;
  public percliberacaovendedor: number;
  public percliberacaogestor: number;
  public guidclientenapis: string;

  constructor() { } 
}
